import { Component,  Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { SaveDashboardModalData } from 'src/shared/models/dashboard.model';
import { DashboardService } from '../../dashboard.service';

@Component({
    selector: 'cv-save-dashboard-modal',
    templateUrl: './save-dashboard-modal.component.html',
    styleUrls: ['./save-dashboard-modal.component.scss']
})
export class SaveDashboardModalComponent implements OnInit {
    @Input() title: string;
    @Input() type: string;
    @Input() data: SaveDashboardModalData;
    @Input() showFolder = true;

    isSaving = false;
    invalidCharsRegex = new RegExp('^([^\\\\\/\!\+\<\>\?\#\&\,\%])*$');
    invalidDescriptionCharsRegex = new RegExp('^([^\\\\\/\!\+\<\>\?\#\&\%])*$');
    isCXOne = false;
    isPatternValid = true;
    isNameValid = true;
    textLimit = 50;
    hidePlural = false;
    name: string;
    templateName: string;
    requiredField: string;
    showLoader = false;
    isReport = false;

    constructor(
        public dashboardService: DashboardService,
        public activeModal: NgbActiveModal,
        public config: CvConfigurationService,
        public cvLocalizationService: CVLocalizationService,
    ) {
        this.isCXOne = config.isCxOne;
    }

    ngOnInit() {
        this.ngOnInitAsync();
    }

    async ngOnInitAsync(){
        await this.cvLocalizationService.GetSection("Dashboard_Input");
        this.requiredField = this.cvLocalizationService.getCachedText("Dashboard_Input", "Required_Field", "Please fill out this field");
        this.characterLimit(this.data?.dashboardName);

        if (this.type === "FromTemplate") {
            this.templateName = this.data?.dashboardName;
            this.data.dashboardName = "";
        }
        if (this.type === "Report") {
            this.isReport = true;
        }
    }

    async save() {
        if (this.isSaving) {
            return;
        }

        this.isSaving = true;

        switch (this.type) {
            case "CopyDashboard": {
                const copiedDashboard = await this.dashboardService.copyDashboardWithParams(
                    this.data.key,
                    this.data.dashboardName,
                    this.data.folder,
                    this.data.description,
                    this.data.iscxone
                );
                this.activeModal.close(copiedDashboard);
                break;
            }
            case "SaveTemplate": {
                const savedTemplate = await this.dashboardService.copyDashboardFromTemporaryDashboard(
                    this.data.key,
                    this.data.dashboardName,
                    this.data.folder,
                    this.data.description
                );
                this.activeModal.close(savedTemplate);
                break;
            }
            case "Report":
            case "EditDashboard": {
                const editedDashboard = await this.dashboardService.updateDashboardDetails(
                    this.data.key,
                    this.data.dashboardName,
                    this.data.folder,
                    this.data.description,
                    this.data.iscxone,
                );
                this.activeModal.close(editedDashboard);
                break;
            }
            case "NewDashboard": {
                const newDashboard = await this.dashboardService.createNewDashboard(
                    this.data.key,
                    this.data.dashboardName,
                    this.data.folder,
                    this.data.description,
                    this.data.iscxone,
                );
                this.dashboardService.newDashboardCreated.emit();
                this.activeModal.close(newDashboard);
                break;
            }
            case "FromTemplate": {
                this.showLoader = true;
                const copiedDashboard = await this.dashboardService.copyDashboardFromSystemTemplate(
                    this.data.key,
                    this.data.dashboardName,
                    this.data.folder,
                    this.data.description,
                    this.data.iscxone,
                );
                this.dashboardService.newDashboardCreated.emit();
                this.activeModal.close(copiedDashboard);
                break;
            }
            default: {
                this.activeModal.close();
            }
        }
    }

    isStringEmpty(input: string) {
        return !input || !input.trim();
    }

    characterLimit(value: string) {
        this.textLimit = 50 - value.length;
        if (this.textLimit === 1) {
            this.hidePlural = true;
        }
        else {
            this.hidePlural = false;
        }
        const editName = value.trim();
        if (!this.invalidCharsRegex.test(editName.toLocaleLowerCase()) && !editName.toLocaleLowerCase().match(this.invalidCharsRegex)){
            this.isPatternValid = false;
        }else {
            this.isPatternValid = true;
        }
    }
    
    getTextLimitMessage() {
        if (this.hidePlural)
            return this.cvLocalizationService.Format(
                this.cvLocalizationService.getCachedText("Dashboard_Input", "Character_Limit_Singular", "{0} character remaining"), this.textLimit
            );
        else 
            return this.cvLocalizationService.Format(
                this.cvLocalizationService.getCachedText("Dashboard_Input", "Character_Limit", "{0} characters remaining"), this.textLimit
            );
    }
}
